import { createBv } from '@bv/plugins';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import FocusTrap from 'primevue/focustrap';
import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';

import components from '@/components/shared/components';
import { messages } from '@/locale';
import { mainRoutes, modules } from '@/router/main/main.router';

import App from './App.vue';

const app = createApp(App);

const pinia = createPinia();

import '@/assets/sass/_main.scss';

const bv = createBv({
  i18n: { messages },
  pinia,
  mainRoute: mainRoutes,
  sidebar: { modules },
  injectAuthRoutes: true,
});

app.use(bv);

// global components configuration
app.use(components);

// primeVue configuration
import '@/assets/sass/_prime.scss';
app.use(PrimeVue, {
  theme: {
    preset: definePreset(Aura),
    options: {
      prefix: 'p',
      darkModeSelector: 'dark-theme',
      cssLayer: {
        name: 'primevue',
        order: 'vuetify, tailwind, primevue',
      },
    },
  },
});

app.directive('focustrap', FocusTrap);

// Click Away configuration
app.use(VueClickAway);

app.mount('#app');
